<template>
  <div>
    <div class="print-container" id="dy" ref="htmlDom">
      <div id="majors" style="width: 100%;margin: 0 auto;display: flex;justify-content: center">
        <div id="major" class="report-section" style="width: 1050px;">
          <div class="report-content">
            <div v-show="flag">
              <div id="show-results">
                <el-row :gutter="24" id="pdfDom">
                  <el-col style="padding-left: 36px; padding-right: 36px;">
                    <div class="result-section">
                      <div class="report-title">
                        <span>{{ student.name }}</span>
                        <span style="margin-left: 1em;">大学专业方向探索报告</span>
                      </div>
                      <div class="report-desc indent-2">
                        选择大学专业对考生未来发展至关重要。考生被喜次、擅长目符合自身特质特点的专业录取，有助于调学习的积极性，主动性，甚至激发潜能，从而给未来的升学或家业打好坚实基础。因此，我们选择从“专业意向度”“学科擅长度”“职业兴趣倾向”三个方面引导考生探索最为适合的大学专业方向。
                      </div>
                      <div>
                        <div class="report-desc-title">
                          一、专业意向度
                        </div>
                        <div>
                          <el-table :data="chooseMajorList">
                            <el-table-column type="index" width="50">
                            </el-table-column>
                            <el-table-column prop="majorName" label="门类">
                            </el-table-column>
                            <el-table-column prop="parentMajorName" label="专业类">
                            </el-table-column>
                            <el-table-column prop="score" label="意向度">
                              <template slot-scope="scope">
                                <el-rate v-model="scope.row.score" show-text disabled :colors="colors"
                                  :texts="subjectRateTexts" text-color="#666666">
                                </el-rate>
                              </template>
                            </el-table-column>
                          </el-table>
                        </div>
                      </div>
                      <div>
                        <div class="report-desc-title">
                          二、学科擅长程度
                        </div>
                        <div class="report-desc indent-2">
                          做自己擅长的事情通常会比较轻松、高效，反之，则容易焦虑、挫败，由于不同大学专业对学生的能力要求有所不同，所以学生在进择大学专业时务必要评估自己的能力结构是否能支撑学
                          好所选专业，虽然，各大学专业的课程不同于中学课程，但却与中学课程有着密切的联系，我们可以通过对中学课程的擅长程度来选择大学专业，需要注意的是，在评估擅长程度时，既要
                          看学业成绩，还要看自己平时的学习表现和感受。
                        </div>
                        <div class="subject-test">
                          <div class="test-content" v-for="item in subjectList">
                            <span class="name">{{ item.name }}</span>
                            <div class="rate-box">
                              <el-rate v-model="item.score" show-text disabled :colors="colors" :texts="subjectRateTexts"
                                text-color="#666666">
                              </el-rate>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="report-desc-title">
                          三、职业兴趣倾向
                        </div>
                        <div class="report-desc indent-2">
                          霍兰德职业兴趣测试 (self-Directed Searh) 是由美国职业指导专家兰 Jh holad) 根据他本人大量的职业咨询经验及其职业类型理论编制的测评工具，已经在全世界被)
                          泛应用。霍兰德认为个人职业兴趣特性与职业之间有一种内在的对应关系，通过测评能够帮助测试者了解自身职业兴趣倾向，从而做好职业规划或大学专业选择。该测试属于典型行为现
                          试，测试者只要根据自己的真实情况如实作答即可。
                        </div>
                        <div>
                          <p class="txt-c title-set m-t-20">霍兰德职业兴趣倾向测试(SDS)</p>
                          <div class="report-desc indent-2">
                            {{ resultsData.reportDesc }}
                          </div>
                          <div v-if="svgRadar" id="histogram" class="histogram-section"
                            :class="{ 'histogram-section-radar': resultsData.tableSet.tableName == 1 }"
                            style="margin: 0 auto;" v-html="svgRadar">
                          </div>
                          <div v-else style="padding: 20px 0;text-align: center;color: #999;">
                            <i class="el-icon-warning-outline"></i>
                            <span>暂无测评结果</span>
                          </div>
                        </div>
                        <div style="page-break-inside: avoid;">
                          <p class="txt-c summary-title m-t-20">{{ resultsData.tableResult.upContent }}</p>
                          <p class="txt-c summary-title m-t-20 indent-2" style="font-weight: 600">
                            {{ resultsData.tableResult.downContent }}</p>
                        </div>
                        <div style="page-break-inside: avoid;">
                          <p class="txt-c title-set m-t-20">{{ resultsData.topicReport.titleWarning }}</p>
                          <div class="chart-summary m-t-20"
                            v-for="(item, index) in resultsData.topicReport.topicReportList">
                            <div class="summary-txt">
                              {{ item.title }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div class="report-desc-title">
                          四、专业方向探索结果
                        </div>
                        <div class="m-t-20" v-loading="loading">
                          <div>
                            <div class="report-desc indent-2">
                              意向指数、擅长指数、适配指数分别反映了专业意向度、学科擅长度、职业兴趣倾向的测量结果，推荐指数是三个指数的综合计算结果，反映了专业类的匹配程度。推荐指数得分越高，说明该专业类综合匹配度越高。探索结果会按照分数由高到低的顺序展示前
                              20 个专业类，不足 20 个时按照实际数目展示。</div>
                            <table v-if="results.length > 0" width="100%;" style="margin-bottom: 30px;margin-top: 20px;"
                              id="result">
                              <tr>
                                <th>序号</th>
                                <th>专业(类)名称</th>
                                <th>意向指数</th>
                                <th>擅长指数</th>
                                <th>适配指数</th>
                                <th>推荐指数</th>
                              </tr>
                              <tr v-for="(item, index) in results">
                                <th style="font-weight: normal;">{{ index + 1 }}</th>
                                <th style="font-weight: normal;">{{ item.majorName }}</th>
                                <th>
                                  <el-rate v-model="item.intention" disabled :colors="colors" text-color="#ff9900"
                                    score-template="{value}">
                                  </el-rate>
                                </th>
                                <th>
                                  <el-rate v-model="item.Proficiency" disabled :colors="colors" text-color="#ff9900"
                                    score-template="{value}">
                                  </el-rate>
                                </th>
                                <th>
                                  <el-rate v-model="item.Fitness" disabled :colors="colors" text-color="#ff9900"
                                    score-template="{value}">
                                  </el-rate>
                                </th>
                                <th>
                                  <el-rate v-model="item.recommend" disabled :colors="colors" :icon-classes="iconClasses"
                                    disabled-void-icon-class="icon iconfont icon-aixin">
                                  </el-rate>
                                </th>
                              </tr>
                            </table>
                            <div v-else style="padding: 20px 0;text-align: center;color: #999;">
                              <i class="el-icon-warning-outline"></i>
                              <span>专业方向探索结果</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="npt">
        <br>
        <el-button style="background-color: #1264ff;color: white;margin-top: 20px;" circle v-print="'#major'">打印
        </el-button>
        <br>
        <el-button style="background-color: #7870b6;color: white;margin-top: 20px;" circle @click="getPdf('#majors')">下载
        </el-button>
        <br>
        <el-button style="background-color: green;color: white;margin-top: 20px;" circle @click="goBack()">返回
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from "@/util/request";
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

export default {

  data() {
    return {
      loading: false,
      stuId: null,
      student: null,
      // 专业方向 start
      testName: '',
      flag: true,
      userId: null,
      subjectList: [],
      colors: ['#F96630', '#F96630', '#F96630'],
      majorRateTexts: ['不喜欢', '能接受', '有意向', '喜欢', '特喜欢'],
      subjectRateTexts: ['很不擅长', '不太擅长', '中等水平', '比较擅长', '特别擅长'],
      iconClasses: ['icon iconfont icon-aixin', 'icon iconfont icon-aixin', 'icon iconfont icon-aixin'],
      chooseMajorList: [],
      results: [],
      Majorx: [],
      resultsData: {
        id: "",
        testId: "",
        reportDesc: "",
        isShowReportDesc: 0,
        tableSet: {},
        isShowTableSet: 0,
        tableResult: {},
        isShowTableResult: 0,
        topicReport: {},
        isShowTopicReportList: [],
        moreSuggestTitle: "",
        moreSuggest: "",
        isShowMoreSuggest: 0,
        reportResult: {},
        isShowReportResult: 0,
        lastImage: [],
        isShowLastImage: []
      },
      htmlTitle: '测评',
      testId: 1,
      chartThemeColor: ['#37A2DA', '#dd6b66', '#c23531', '#4EA397', '#8D98B3'], // 图表色系
      svgRadar: ''
    }
  },
  created() {
    this.$once('hook:beforeDestroy', () => {
      this.radarChart && this.radarChart.dispose()
      this.histogramChart && this.histogramChart.dispose()
    })
    this.init()
  },
  mounted() {},
  methods: {
    // 返回
    goBack() {
      this.$router.go(-1)
    },
    // 基础信息表格内容获取
    init() {
      const user = JSON.parse(sessionStorage.getItem('user'))
      this.userId = user.userId
      this.getSubjectName()
      if (user.userType == 3) {
        this.student = JSON.parse(localStorage.getItem('stu'))
        this.stuId = this.student.id
        this.student.examMsg = JSON.parse(this.student.examMsg)
        this.student.checkMsg = JSON.parse(this.student.checkMsg)
        this.getMajor()
      } else if (user.userType == 4) {
        this.student = JSON.parse(localStorage.getItem('stu'))
        this.getStudentInfo()
      }
    },

    // 下载pdf
    getPdf(url) {
      let title = ''
      if (url == '#programmes') {
        title = this.student.name + "方案信息";
        window.open(`${this.$constants.serverUrl}/mendaoVoluntary/stuScheme/getPrintSchemePdf?stuId=` + this.stuId);
        return;
      } else if (url == '#datas') {
        title = this.student.name + "高考志愿填报档案表";
      } else if (url == '#newschool') {
        title = this.student.name + "选科方案";
      } else if (url == '#majors') {
        title = this.student.name + "大学专业方向探索报告";
      }

      html2Canvas(document.querySelector(url), {
        allowTaint: true,
        taintTest: false,
        logging: false,
        useCORS: true,
        dpi: window.devicePixelRatio * 1.5, //将分辨率提高到特定的DPI 提高四倍
        // dpi:300,
        scale: 1.5 //按比例增加分辨率
      }).then(canvas => {
        var pdf = new JsPDF('p', 'mm', 'a4');    //A4纸，纵向

        var ctx = canvas.getContext('2d'),
          a4w = 260, a4h = 280,    //A4大小，210mm x 297mm，四边各保留10mm的边距，显示区域190x277
          imgHeight = Math.floor(a4h * canvas.width / a4w),    //按A4显示比例换算一页图像的像素高度
          renderedHeight = 0;
        ctx.mozImageSmoothingEnabled = false;
        ctx.webkitImageSmoothingEnabled = false;
        ctx.msImageSmoothingEnabled = false;
        ctx.imageSmoothingEnabled = false;
        while (renderedHeight < canvas.height) {
          var page = document.createElement("canvas");
          page.width = canvas.width;
          page.height = Math.min(imgHeight, canvas.height - renderedHeight);//可能内容不足一页

          //用getImageData剪裁指定区域，并画到前面创建的canvas对象中
          page.getContext('2d').putImageData(ctx.getImageData(0, renderedHeight, canvas.width, Math.min(imgHeight, canvas.height - renderedHeight)), 0, 0);
          pdf.addImage(page.toDataURL('image/jpeg', 1.0), 'JPEG', -25, 10, a4w, Math.min(a4h, a4w * page.height / page.width));    //添加图像到页面，保留10mm边距

          renderedHeight += imgHeight;
          if (renderedHeight < canvas.height) {
            pdf.addPage();//如果后面还有内容，添加一个空页
          }
        }
        //保存文件
        pdf.save(title + '.pdf')

      })
    },
    // 专业方向探索结果
    showResult() {
      this.loading = true
      request({
        method: 'post',
        url: 'stuMajorResult/showResult',
        data: {
          stuMajorRel: this.Majorx,
          stuSubjectRel: this.subjectList,
          mathTests: this.resultsData.tableSet.tableTestMsg
        }
      }).then(res => {
        this.results = res.data
        this.loading = false
      })
    },
    // 专业方向--获取专业
    getMajor() {
      request({
        method: 'get',
        url: 'majorCategoryInfo/getMajor',
        params: {
          pageNum: 1,
          pageSize: 999999,
          stuId: this.stuId
        }
      }).then(res => {
        this.Majorx = res.data;
        this.getStuMajor()
      })
    },
    // 专业意向--学科擅长程度
    getStuMajor() {
      request({
        method: 'get',
        url: 'stuMajorRel/getStuMajor',
        params: {
          stuId: this.stuId
        }
      }).then(res => {
        for (let i = 0; i < res.data.length; i++) {
          for (let j = 0; j < this.Majorx.length; j++) {
            if (res.data[i].maojorId == this.Majorx[j].id) {
              this.$set(this.Majorx[j], "score", res.data[i].score)
              this.$set(this.Majorx[j], "relId", res.data[i].id)
            }
          }
        }
        this.Major = JSON.parse(JSON.stringify(this.Majorx))
        this.getMendaoStu()

        if (res.data) {
          let list = []
          res.data.forEach(item => {
            if (item.score > 0) {
              list.push(item)
            }
          })
          this.chooseMajorList = list
        }
      })
    },
    // 专业方向
    getSubjectName() {
      request({
        method: 'Get',
        url: 'subjectInfo/getSubjectName',
      }).then(res => {
        this.subjectList = res.data
        this.getStuSubject()
      })
    },
    getStuSubject() {
      request({
        method: 'get',
        url: 'stuSubjectRel/getStuSubject',
        params: {
          stuId: this.stuId
        }
      }).then(res => {
        for (let s = 0; s < this.subjectList.length; s++) {
          this.$set(this.subjectList[s], "score", 0)
        }
        for (let i = 0; i < res.data.length; i++) {
          for (let j = 0; j < this.subjectList.length; j++) {
            if (res.data[i].subjectId == this.subjectList[j].id) {
              this.$set(this.subjectList[j], "score", res.data[i].score)
              this.$set(this.subjectList[j], "relId", res.data[i].id)
            }
          }
        }
      })
    },
    // 获取测评详情
    getTestDetail() {
      request({
        method: 'get',
        url: 'mendao/getTestById',
        params: {
          data: JSON.stringify({
            testId: this.testId
          })
        }
      }).then((res) => {
        if (res.code === 1) {
          this.testName = res.data.testName;
          this.htmlTitle = this.testName;
        } else {
          this.$message.error(res.data.message);
        }
      }).catch((res) => {
      });
    },

    // 查询学生测评记录
    getMendaoStu() {
      request({
        method: 'get',
        url: 'mendao/getMenDaoStu',
        params: {
          stuId: this.student.id
        }
      }).then(res => {
        if (res.code == 0 || res.code == 200) {
          if (!res.data) {
            this.$message({ message: res.msg, type: 'warning' });
          }
          this.getResultDetails(res.data);
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    // 查看提交的测评结果信息
    getResultDetails(records) {
      request({
        method: 'post',
        url: 'mendao/showCommitTest',
        data: {
          testId: this.testId,
          stuId: records.id
        }
      }).then((res) => {
        if (res.code === 1) {
          this.resultsData = res.data;
          this.resultsData.reportResult = JSON.parse(res.data.reportResult)
          this.getTestReportDetail()
        } else {
          this.$message.error(res.data.message);
        }
      }).catch((res) => {
      });
    },
    // 获取测评结果详情
    getTestReportDetail() {
      request({
        method: 'get',
        url: 'mendao/getTestReport',
        params: {
          data: JSON.stringify({
            testId: this.testId
          })
        }
      }).then((res) => {
        if (res.code === 1) {
          // 整理题组标题
          if (this.resultsData.topicReport.topicReportList) {
            for (let i = 0; i < this.resultsData.topicReport.topicReportList.length; i++) {
              let titleObj = {
                text: this.resultsData.topicReport.topicReportList[i].title
              };
              this.resultsData.topicReport.topicReportList[i].formatTitle = titleObj;
            }
          }

          // moreSuggest
          if (this.resultsData.moreSuggest) {
            for (let i = 0; i < this.resultsData.moreSuggest.length; i++) {
              let suggestTitle = {
                text: this.resultsData.moreSuggest[i].title
              };
              this.resultsData.moreSuggest[i].formatTitle = suggestTitle;
            }
          }
          if (this.resultsData.reportResult.title && this.resultsData.isShowReportResult == 1) {
            let resultTitle = {
              text: this.resultsData.reportResult.title
            };
            this.resultsData.reportResult.formatTitle = resultTitle;
          }
          // 图标数据
          this.chartsInfo();
          this.showResult()
        } else {
          this.$message.error(res.message);
        }
      }).catch((res) => {
      });
    },
    // 图表设置
    chartsInfo() {
      // 获取色系 chartThemeColor
      let chartColor = '#c23531';
      if (this.resultsData.tableSet.tableColor) {
        chartColor = this.chartThemeColor[this.resultsData.tableSet.tableColor - 1]
      }

      let baryAxisData = [];
      let barSeriesData = [];
      let radaryAxisData = [];
      let radarSeriesData = [];
      let maxNum = 0;

      for (let i = 0; i < this.resultsData.tableSet.tableTestMsg.length; i++) {
        let yObj = {
          name: this.resultsData.tableSet.tableTestMsg[i].topicGroupCode + ' ' + this.resultsData.tableSet.tableTestMsg[i].unitName,
          max: 5
        };
        if (this.resultsData.tableSet.tableTestMsg[i].unitScore == 'null') {
          this.resultsData.tableSet.tableTestMsg[i].unitScore = '0';
        }
        maxNum = (maxNum - this.resultsData.tableSet.tableTestMsg[i].unitScore) > 0 ? maxNum : this.resultsData
          .tableSet.tableTestMsg[i].unitScore;
        baryAxisData.push(this.resultsData.tableSet.tableTestMsg[i].unitName);
        barSeriesData.push(this.resultsData.tableSet.tableTestMsg[i].unitScore);
        radaryAxisData.push(yObj);
        radarSeriesData.push(this.resultsData.tableSet.tableTestMsg[i].unitScore);
      }

      radaryAxisData.forEach(e => {
        e.max = maxNum;
      });

      // 获取图标类型
      if (this.resultsData.tableSet.tableName == 2) { // 条形图
        setTimeout(() => {
          this.barChartUtil(chartColor, baryAxisData, barSeriesData);
        }, 100);
      } else if (this.resultsData.tableSet.tableName == 1) { // 雷达图
        setTimeout(() => {
          this.radarChartUtil(chartColor, radaryAxisData, radarSeriesData);
        }, 100);
      }

    },
    // 条形图
    barChartUtil(chartColor, yAxisData, seriesData) {
      let histogramDom = document.getElementById("histogram");
      this.histogramChart = this.$echarts.init(histogramDom);
      seriesData = seriesData.reverse();
      yAxisData = yAxisData.reverse();
      this.histogramChart.setOption({
        color: [chartColor],
        title: {
          text: this.resultsData.tableTitle ? this.resultsData.tableTitle : '图表数据',
          textAlign: 'left',
          textStyle: {
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 'normal',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01,],
          max: 100
        },
        yAxis: {
          type: 'category',
          data: yAxisData,
        },
        grid: {
          left: 70
        },
        series: [{
          type: 'bar',
          data: seriesData,
        }]
      }, true);
    },
    // 雷达图
    radarChartUtil(chartColor, yAxisData, seriesData) {
      for (let i = 0; i < yAxisData.length; i++) {
        yAxisData[i].max = 10;
      }

      let chatOption = {
        color: [chartColor],
        title: {
          text: this.resultsData.tableTitle ? this.resultsData.tableTitle : '图表数据',
          subtext: '',
          // textAlign:'center',
          textStyle: {
            fontSize: 22,
            lineHeight: 30,
          },
          // 标题的位置，此时放在图的底边
          left: 'center',
          top: 'top',
        },
        tooltip: {},
        radar: {
          name: {
            textStyle: {
              fontSize: 16,
              color: '#333',
              backgroundColor: '#fff',
              borderRadius: 3,
              padding: [3, 5],
              textAlign: "center"
            }
          },
          indicator: yAxisData
        },
        series: [{
          type: 'radar',
          data: [{
            value: seriesData,
            name: this.resultsData.tableTitle,
            label: {
              normal: {
                show: true,
                formatter: function (params) {
                  return params.value
                }
              }
            }
          }]
        }]
      }
      let width = 600, height = 670
      // 在 SSR 模式下第一个参数不需要再传入 DOM 对象
      this.radarChart = this.$echarts.init(null, null, {
        renderer: 'svg', // 必须使用 SVG 模式
        ssr: true, // 开启 SSR
        width,
        height
      });

      this.radarChart.setOption(chatOption);

      // 输出svg字符串
      const svgStr = this.radarChart.renderToSVGString();
      this.svgRadar = svgStr

    },

    // 获取学生信息
    getStudentInfo() {
      request({
        method: 'get',
        url: 'students/getStu',
        params: {
          Id: this.userId
        }
      }).then(res => {
        this.student = res.data
        this.stuId = this.student.id
        this.student.examMsg = JSON.parse(this.student.examMsg)
        this.getMajor()
      })
    },
  },


}
</script>
<style lang="stylus" rel="stylesheet/stylus">
// 颜色定义规范
$color-background = #fff
$color-background-d = rgba(0, 0, 0, 0.3)
$color-highlight-background = #333
$color-dialog-background = #666
$color-theme = #e96558
$color-theme-d = rgba(233, 101, 88, 0.5)

$color-text = #fff
$color-text-e = rgba(0, 0, 0, 0.1)
$color-text-d = rgba(0, 0, 0, 0.3)
$color-text-l = rgba(0, 0, 0, 0.5)
$color-text-ll = rgba(0, 0, 0, 0.8)

#show-results
  background: #fff
  font-size $font-size-medium
  color $color-text-ll
  word-wrap break-word
  word-break break-all


  #pdfDom
    background: #fff

  .result-section
    padding: 0

  .user-info
    font-size: 18px

  .user-info-tip
    font-size 18px

  .txt-c
    text-align center

  .title-set
    font-size $font-size-large-l
    font-weight 600

  .summary-title
    font-size 16px

  .subtitle-set
    font-size $font-size-large

  .test-report
    font-size: $font-size-medium-x
    line-height 28px
    font-weight 600

  .histogram-section
    width: 600px
    height: 670px

  .chart-summary
    padding: 10px 10px
    border-radius: 4px


  .summary-txt
    padding-top: 12px
    line-height 28px
    text-indent: 2em;
    font-size: $font-size-medium-x

  .result-img-list
    padding: 20px

    img
      display block
      max-width 100%
      margin: 0 auto
      margin-bottom: 5px

  .btn-box
    padding: 20px 0
    text-align center
body, html {
  height: inherit
}

#answer
  text-align center

  .answer-section
    width: 900px
    margin 0 auto

  .test-title
    font-size $font-size-large-l
    color $color-text-ll
    font-weight 600
    text-align center

  .test-arrow
    color $color-text-d

  .test-schedule
    color $color-text-d

  .test-section
    text-align left
    padding 20px 0
    color $color-text-ll

    .topic
      padding-bottom: 10px
      font-size 30px
      line-height 40px
      font-weight 600

    .options-box
      display flex
      justify-items center
      align-items center
      cursor pointer
      width 400px
      margin 0 auto

      .option-content
        flex 1
        font-size $font-size-large
        line-height 32px
        font-weight 600

      .option-choose
        width 50px
        font-size 24px
        color: $color-text-l

        &.checked
          color: $color-theme

    .color-main
      color $color-theme

  .test-operate
    text-align center

  @media screen and (max-width: 768px) {
    .answer-section {
      width: auto
      padding 0 10px
    }

    .test-section {
      .options-box {
        width: 100%
      }
    }
  }

.jc {
  font-weight: bold;
}

.jl {
  font-size: 18px;
  font-weight: bold;
  margin-right: 2%;
  display: inline-block;
  width 10em
  margin-top 10px
}

.tp {
  width 100%
  margin auto
  line-height 30px
}

#dy #npt {
  top: 20%;
  right 5%;
  z-index: 99999;
  position: fixed;
}

#dy #npt1 {
  top: 20%;
  z-index: 99999;
  position: fixed;
  right 5%;
}

#npt1 button {
  color: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  font-size: 15px;
  font-weight: initial;
  padding: 0;
  text-align: center;
}

#npt1 button span {
  display: inline-block;
  margin: auto;
}

#dy {
  font-size 15px
  -webkit-print-color-adjust: exact
}

@media print {
  #baseData, #programme, #newschools, #major {

    * {
      -webkit-print-color-adjust: exact;
      -moz-print-color-adjust: exact;
      -ms-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    border: solid 1px #fff;
  }

}

#programmes table tr {

  page-break-inside: avoid;

}

#newschool table tr {

  page-break-inside: avoid;

}

//#dy .el-table {
//  border-color black
//  border-bottom 1px solid #000000
//  border-right 1px solid #000000
//}

#tables {
  width: 400px; //表格的宽度
  border-top: 1px solid #999;
  border-left: 1px solid #999;
  border-spacing: 0; /*把单元格间隙设置为0*/
  // font-family: "宋体"
}

#tables th, td {
  height: 40px;
  font-weight: 400;
}

#result {
  tr {
    border-bottom 1px solid #d4d4d4
    height 50px
  }
}


</style>

<style lang="stylus" scoped>
pageWidth = 1400px
$color-theme = #f96630
$color-table-border = #999

.print-container
  width: pageWidth;
  margin: 0 auto;
  font-size: 14px;

  div
    box-sizing: border-box;

  .m-l-20
    margin-left 20px

  .b-r-l
    border-left: 1px solid $color-table-border;
  .b-r-r
    border-right: 1px solid $color-table-border;
  .p-0-10
    padding: 0 10px;

  .indent-2
    text-indent: 2em
</style>

<style scoped media="print">
/*指定打印的分页*/
/**
/deep/ section {
  page-break-after: always;
}
 */
/*避免出现空白尾页*/
html,
body,
#app {
  height: 98% !important;
  margin: 0px;
  padding: 0px;
}
</style>
<style>
.print-container {
  width: 1400px;
  margin: 0 auto;
  font-size: 14px;
}

.print-container div {
  box-sizing: border-box;
}

.m-l-20 {
  margin-left: 20px
}

.m-t-20 {
  margin-top: 20px
}

.b-r-l {
  border-left: 1px solid #999;
}

.b-r-r {
  border-right: 1px solid #999;
}

.p-0-10 {
  padding: 0 10px;
}

.txt-l {
  text-align: left !important;
}

/* 专业方向 start */
.report-section {
  width: 1050px;
  padding: 0;
}

.report-section .report-content {
  width: 1050px;
  margin: 50px auto;
}

.report-section .report-title {
  width: 100%;
  margin: 40px auto;
  font-weight: bold;
  font-size: 25px;
  text-align: center;
}

.report-section .report-desc {
  line-height: 28px;
  font-size: 16px;
  color: #333;
}

.report-section .report-desc-title {
  padding: 30px 0;
  line-height: 40px;
  font-size: 18px;
  color: #000;
  font-weight: 600;
}

.report-section .subject-test {
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding: 0 30px;
}

.report-section .subject-test .test-content {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 33.3%;
  height: 50px;
  padding: 0 10px;
}

.report-section .subject-test .test-content .name {
  width: 48px;
  color: #333333;
}

.report-section .subject-test .test-content .rate-box {
  width: 186px;
  padding-left: 10px;
  cursor: pointer;
}

.report-section .subject-test .test-content .del {
  width: 40px;
  text-align: right;
  color: #FC6621;
  cursor: pointer;
}

/* 专业方向 end */
</style>
